// src/components/AssignDriver.js
import React, { useState, useEffect, useMemo } from "react";
import axios from "../axiosConfig"; // configured axios instance
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AssignDriver() {
  const { t } = useTranslation("assign_driver");

  const [drivers, setDrivers] = useState([]); // available drivers
  const [selectedDriverId, setSelectedDriverId] = useState(""); // selected driver id
  const { loadId } = useParams();
  const navigate = useNavigate();

  // Fetch drivers on mount
  useEffect(() => {
    let cancelled = false;

    const fetchDrivers = async () => {
      try {
        const response = await axios.get("/drivers");
        if (!cancelled) setDrivers(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching drivers:", error);
        // optional user feedback (keeps behavior minimal)
        window.alert(t("alerts.fetchError"));
      }
    };

    fetchDrivers();

    return () => {
      cancelled = true;
    };
  }, [t]);

  const driverOptions = useMemo(() => {
    const yes = t("availability.available");
    const no = t("availability.notAvailable");

    const field = (k) => t(`driverFields.${k}`);

    return (Array.isArray(drivers) ? drivers : []).map((driver) => {
      const labelParts = [
        `${field("name")}: ${driver?.name ?? "—"}`,
        `${field("dob")}: ${driver?.date_of_birth ?? "—"}`,
        `${field("id")}: ${driver?.driver_id ?? "—"}`,
        `${field("license")}: ${driver?.driver_license ?? "—"}`,
        `${field("tachoNumber")}: ${driver?.driver_tacho_number ?? "—"}`,
        `${field("userId")}: ${driver?.userId ?? "—"}`,
        `${field("qualifications")}: ${driver?.qualifications ?? "—"}`,
        `${field("idPhoto")}: ${driver?.driver_id_photo ? yes : no}`,
        `${field("licensePhoto")}: ${driver?.driver_license_photo ? yes : no}`,
        `${field("tachoCardPhoto")}: ${driver?.driver_tacho_card_photo ? yes : no}`
      ];

      return {
        value: String(driver?.id ?? ""),
        label: labelParts.join(", ")
      };
    });
  }, [drivers, t]);

  // Assign driver to load
  const handleAssignDriver = async () => {
    try {
      await axios.post(`/loads/${loadId}/assign-driver`, {
        driverId: selectedDriverId
      });

      window.alert(t("alerts.success"));
      navigate("/dashboard");
    } catch (error) {
      console.error("Error assigning driver:", error);
      window.alert(t("alerts.assignError"));
    }
  };

  return (
    <div className="assign-driver-container">
      <h1>{t("title")}</h1>

      <div className="form-group">
        <label>{t("labels.chooseDriver")}</label>

        <select
          value={selectedDriverId}
          onChange={(e) => setSelectedDriverId(e.target.value)}
        >
          <option value="">{t("options.selectDriver")}</option>

          {driverOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <button
        className="assign-btn"
        onClick={handleAssignDriver}
        disabled={!selectedDriverId}
      >
        {t("buttons.assign")}
      </button>
    </div>
  );
}

export default AssignDriver;
